<template>
  <div class="address">
    <div class="formBox">
      <div class="labelItem">
        <div class="label">选择地区</div>
        <div class="value align-center" style="justify-content: flex-end" @click="toLocation()">
          {{address || '选择地区'}}
          <img src="/static/images/default/r.png" style="width: 8px; height: 16px; margin-left: 6px"/>
        </div>
      </div>
      <div class="labelItem">
        <div class="label">详细地址</div>
        <div class="value align-center">
          <van-field
              v-model="detailAddress"
              maxlength="50"
              type="input"
              placeholder="请输入详细地址"
              class="contentField"
              style="color: #999"
          />
        </div>
      </div>
    </div>
    <div class="save" @click="save">
      保存
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Field, Toast} from 'vant';
import eventBus from "@/libs/eventBus";
import {getLocation, updateLocation} from "@/api/location";
Vue.use(Field)

export default {
  name: "address",

  data(){
    return {
      address: null,
      location: null,
      lat: null,
      lng: null,
      detailAddress: null,
      id: null
    }
  },

  methods:{
    toLocation(){
      eventBus.$on('confirmLocation', (val) =>{
        this.address = val.poiaddress
        this.lat = val.latlng.lat
        this.lng = val.latlng.lng
      })
      this.$router.push({
        path: '/clerk/location/location',
      })
    },
    loadData(){
      getLocation().then(res=>{
        let data = res.data
        if(data.code == 0){
          this.clerkAddress = data.clerkAddress
          if(this.clerkAddress){
            this.id = this.clerkAddress.id
            this.address = this.clerkAddress.address
            this.detailAddress = this.clerkAddress.detailAddress
            this.lat = this.clerkAddress.lat
            this.lng = this.clerkAddress.lng
          }
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    save(){
      if(!this.address){
        return Toast("请选择地址")
      }if(!this.detailAddress){
        return Toast("请输入详细地址")
      }
      Dialog.confirm({
        message: '确认要保存该地址吗',
      }).then(() => {
        updateLocation(
            this.id,
            this.address,
            this.detailAddress,
            this.lat,
            this.lng).then(res=>{
          let data = res.data
          if(data.code == 0){
            Toast("保存成功")
            this.$router.back(-1)
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      })
    }
  },

  mounted(){
    this.loadData()
  }
}
</script>

<style lang="less" scoped>
.address{
  padding: 15px;

  .formBox{
    background: #fff;
    border-radius: 20px;
    padding: 12px;
  }

  .labelItem{
    justify-content: space-between;
    display: flex;
    align-items: center;
    padding: 12px 0;

    .label{
      width: 85px;
      color: #333;
    }

    .value{
      flex: 1;
      color: #999;
    }
  }

  .align-center{
    display: flex;
    align-items: center
  }

  .contentField{
    background: none;
    padding: 0;

    /deep/.van-field__control{
      color: #999 !important;
      text-align: right;
    }

    /deep/input::placeholder{
      color: #999
    }
  }

  .save{
    position: fixed;
    bottom: 85px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    text-align: center;
    padding: 10px 0;
    background: var(--primary-color);
    color: #fff;
    border-radius: 222px;
  }
}
</style>